import React from 'react'

import Location from './Location'
import Time from './Time'

const LocationAndTime = () => {
  return (
    <div className="w-full pb-16">
      <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-[20px] text-primary-100">
        Location & Time Settings
      </h3>

      <Location />

      <Time />
    </div>
  )
}

export default LocationAndTime
